module.exports = __webpack_public_path__ + "img/pers-appartement.76fda392.jpg";